<template>
  <svg id="icon-edit" width="20" height="20" viewBox="0 0 20 20">
    <g fill="none" fill-rule="evenodd">
      <path stroke="currentColor" d="M-309.5-12.5h554v512h-554z"/>
      <path d="M7.365 9.665l5.5-5.5a.55.55 0 0 1 .77 0l2.2 2.2a.55.55 0 0 1 0 .77l-5.5 5.5a.55.55 0 0 1-.385.165h-2.2a.55.55 0 0 1-.55-.55v-2.2a.55.55 0 0 1 .165-.385zM8.3 11.7h1.425l4.95-4.95-1.425-1.425-4.95 4.95V11.7zm5.5-1.1a.55.55 0 0 1 1.1 0v3.3a1.1 1.1 0 0 1-1.1 1.1H6.1A1.1 1.1 0 0 1 5 13.9V6.2c0-.605.495-1.1 1.1-1.1h3.3a.55.55 0 0 1 0 1.1H6.1v7.7h7.7v-3.3z" fill="currentColor" fill-rule="nonzero"/>
    </g>
  </svg>
</template>
